export default {
  markAllAsRead: 'Mark all as read',
};
